






























































































































import Vue from "vue";

const TestProps = {
  props: {
    tires: {
      type: Object,
    },
    locationName: String,
  },
};

export default Vue.extend({
  ...TestProps,
  ...{
    data: () => {
      return {
        diameter: null,
        tireId: 0,
        tire: {
          fiveMm: null,
          threeMm: null,
          twoMm: null,
          belowTwoMm: null,
        },
        badTires: null,
        hideComplexForm: false,
        showTireDialog: false,
        numberRules: [
          (value: any) =>
            value === null || /^[0-9]+$/.test(value) || "Bitte Anzahl korrigieren",
          (value: any) => value == null || value < 101 || "Maximal 100",
        ],
        noTiresAdded: false,
        triedSubmit: false,
      };
    },
    mounted() {
      return;
    },
    methods: {
      resetFormValues() {
        this.tireId = 0;
        this.tire = {
          fiveMm: null,
          threeMm: null,
          twoMm: null,
          belowTwoMm: null,
        };
        this.hideComplexForm = false;
        this.badTires = null;
      },
      addTire() {
        if (!this.tireId) {
          if (!this.badTires) {
            this.triedSubmit = true;
            return;
          } else {
            this.tire.belowTwoMm = this.badTires;
            this.tireId = this.tires[16].types[0].tireId;
          }
        }
        this.triedSubmit = false;
        if (
          !this.tire.belowTwoMm &&
          !this.tire.twoMm &&
          !this.tire.threeMm &&
          !this.tire.fiveMm
        ) {
          this.noTiresAdded = true;
          return;
        }
        const payload = {
          depths: {
            belowTwoMm: parseInt(this.tire.belowTwoMm || "0"),
            twoMm: parseInt(this.tire.twoMm || "0"),
            threeMm: parseInt(this.tire.threeMm || "0"),
            fiveMm: parseInt(this.tire.fiveMm || "0"),
          },
          serviceLocationId: this.$store.getters.location.id,
          tireId: this.tireId,
        };
        // ugly because this.$refs.form.validate() is not typescript ready // missing declaration
        // @see https://stackoverflow.com/questions/52109471/typescript-in-vue-property-validate-does-not-exist-on-type-vue-element/52109899
        if ((this.$refs.tireForm as Vue & { validate: () => boolean }).validate()) {
          this.$store
            .dispatch("addTire", payload)
            .then(() => {
              this.$toast("Danke, die Reifen wurden eingelagert.", {
                timeout: 5000,
              });
            })
            .catch((e) => {
              this.$toast.error(e.response.data.error.message);
            });
          this.showTireDialog = false;
          this.diameter = null;
          this.resetFormValues();
          return;
        }
        this.$toast.error("Bitte korrigieren Sie die Eingaben.");
      },
    },
    watch: {
      diameter(newvalue) {
        this.resetFormValues();
        if (this.tires[newvalue] && this.tires[newvalue].types.length == 1) {
          this.tireId = this.tires[newvalue].types[0].tireId;
        }
      },
    },
  },
});
